export default __webpack_public_path__ + "static/media/RosaryMorning.4248944e.svg";